import React from 'react'
import '../../css/page/refundComponent.css'

class RefundContentEditable extends React.Component{
    constructor(){
        super()
        this.emitChange = this.emitChange.bind(this)
    }

    emitChange(){
        let typeInner = this.richText.value
        this.fakeTextArea.innerText = typeInner
        this.richText.style.height = this.fakeTextArea.offsetHeight + 'px'
        this.props.onChange(typeInner)
    }

    render() {
        return (
            <div className="other-reason-inputType-border">
                <p ref={ref=>this.fakeTextArea = ref} className="fakeTextArea"></p>
                <div className="textArea">
                    <textarea name="other-reason-inputType"
                              ref={ref=>this.richText = ref}
                              onInput={this.emitChange}
                              className="other-reason-inputType"
                              placeholder="请输入描述内容..."
                              maxLength={this.props.limitNum}
                              rows="1">
                    </textarea>
                </div>
            </div>
        )
    }
}

export default RefundContentEditable




// WEBPACK FOOTER //
// ./src/pages/refund/refundContentEditable.js